import KeenSlider from 'keen-slider';

export function registerCenteredSlider() {
    const $sliders = document.querySelectorAll<HTMLElement>('[data-slider="centered"] > [data-slider-container]');

    if (!$sliders.length) {
        return;
    }

    $sliders.forEach($slider => new KeenSlider($slider, {
        loop: true,
        mode: 'free-snap',
        slides: {
            origin: 'center',
            perView: 'auto',
            spacing: 32,
        },
        created(instance) {
            // Initialize controls
            const $parent = instance.container.parentElement!;
            const $prev = $parent.querySelector('[data-slider-prev]');
            const $next = $parent.querySelector('[data-slider-next]');

            // When focusing slide then send the focused slide to the center
            //instance.slides.map((el, idx) => {
            //    el.addEventListener('focus', () => instance.moveToIdx(idx), false);
            //});

            $prev?.addEventListener('click', instance.prev, false);
            $next?.addEventListener('click', instance.next, false);
        },
    }));
}
